export const API_URL = "https://hp-api.onrender.com/api"

export default API_URL;
